import { Theme } from "@mui/material/styles";

export const getStyles = (theme: Theme) => ({
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
    dfr: {
        flexDirection: 'row'
    },
    redTxt: {
        color: 'red'
    },
    orangeTxt: {
        color: 'orange'
    },
    greenTxt: {
        color: 'green'
    },
    selector: {
        margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
        width: '100%',
    },
    modalSelector: {
        margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
        width: '100%',
    },
    pFormControl: {
        margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
        width: '100%',
    },
    inputText: {
        fontSize: 14,
        padding: '8px',
    },
    dfb: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    verticalBtn: {
        margin: 'auto',
        marginTop: theme.spacing(1),
        width: '12rem'
    },
    table: {
        minWidth: 650,
        cursor: 'pointer'
    },
    highlight: {
        backgroundColor: '#3B4B95',
        '& > *': { color: 'white' }
    },
    datePicker: {
        width: '100%',
        margin: `${theme.spacing(2)} ${theme.spacing(2)}`,
    },
    fadeBorder: {
        border: `1px solid ${theme.palette.primary.light}`,
        transition: 'border-color 0.5s linear;',
        // '&:hover': {
        //     'border-color': theme.palette.primary.light
        // }
    },
    hideBorder: {
        border: `1px solid rgb(0,0,0,0)`,
        transition: 'border-color 0.2s linear;',
    }
});
